'use strict';

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var Tar = require('it-tar');

var CID = require('cids');

var configure = require('./lib/configure');

var toUrlSearchParams = require('./lib/to-url-search-params');

var map = require('it-map');

module.exports = configure(function (api) {
  /**
   * @type {import('.').Implements<typeof import('ipfs-core/src/components/get')>}
   */
  function get(_x) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          res,
          extractor,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          _value2,
          header,
          body,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return _awaitAsyncGenerator(api.post('get', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: "".concat(path instanceof Uint8Array ? new CID(path) : path)
                }, options)),
                headers: options.headers
              }));

            case 3:
              res = _context.sent;
              extractor = Tar.extract();
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 7;
              _iterator = _asyncIterator(extractor(res.iterator()));

            case 9:
              _context.next = 11;
              return _awaitAsyncGenerator(_iterator.next());

            case 11:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 15;
              return _awaitAsyncGenerator(_step.value);

            case 15:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 28;
                break;
              }

              _value2 = _value, header = _value2.header, body = _value2.body;

              if (!(header.type === 'directory')) {
                _context.next = 23;
                break;
              }

              _context.next = 21;
              return {
                type: 'dir',
                path: header.name
              };

            case 21:
              _context.next = 25;
              break;

            case 23:
              _context.next = 25;
              return {
                type: 'file',
                path: header.name,
                content: map(body, function (chunk) {
                  return chunk.slice();
                }) // convert bl to Buffer/Uint8Array

              };

            case 25:
              _iteratorNormalCompletion = true;
              _context.next = 9;
              break;

            case 28:
              _context.next = 34;
              break;

            case 30:
              _context.prev = 30;
              _context.t0 = _context["catch"](7);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 34:
              _context.prev = 34;
              _context.prev = 35;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 39;
                break;
              }

              _context.next = 39;
              return _awaitAsyncGenerator(_iterator.return());

            case 39:
              _context.prev = 39;

              if (!_didIteratorError) {
                _context.next = 42;
                break;
              }

              throw _iteratorError;

            case 42:
              return _context.finish(39);

            case 43:
              return _context.finish(34);

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 30, 34, 44], [35,, 39, 43]]);
    }));
    return _get.apply(this, arguments);
  }

  return get;
});